import RunnerSafeType from "./RunnerSafeType.js";

// inner structure of @see https://docs.google.com/document/d/1Tzpf6Z0tahdFu27C_QiIi02eAnVv4zA7S1VMS-UCbCs/edit#bookmark=id.qah3o2svel5d
const RunnerSafe = {
    RunnerId: { key: 'runnerId', name: 'Runner', type: 'NUMBER' },
    FromBase: { key: 'fromBase', name: 'fromBase', type: 'NUMBER' },
    TargetBase: { key: 'targetBase', name: 'targetBase', type: 'NUMBER' },
    Type: { key: 'type', name: 'type', type: RunnerSafeType, enumDefault: RunnerSafeType.Safe.key },
};

export default RunnerSafe;